<div class="uni-table-filter-header" (click)="onOpen()">
  {{ heading }}
  <uni-icon
    name="filter"
    [style]="hasFilters ? 'fas' : 'far'"
    [isLeftSpace]="true"
  ></uni-icon>
</div>
